module.exports = __webpack_public_path__ + "c37f102dd7f0f97632a7e0746538977d.svg";